import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { BusinessUser } from 'src/app/models/business-user.model';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular/ckeditor.component';

@Component({
  selector: 'app-call-description',
  templateUrl: './call-description.component.html',
  styleUrls: ['./call-description.component.scss']
})
export class CallDescriptionComponent implements OnInit {
  @Input()
  set user (value: BusinessUser) {
    this._user = value
  }

  @Output()
  textHasChanged: EventEmitter<string> = new EventEmitter<string>()

  @Output()
  typeHasChanged: EventEmitter<string> = new EventEmitter<string>()

  @Output()
  priorityHasChanged: EventEmitter<string> = new EventEmitter<string>()

  public _user: BusinessUser;
  public descriptionEditor = ClassicEditor;
  public callDetailForm: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
  ) { }

  ngOnInit(): void {
    // this.descriptionEditor.
    this.callDetailForm = this.fb.group({
      type: ["I"],
      priority: ["B"],
      description: [undefined, [Validators.required]]
    });
  }

  public get statusNamed() {
    switch (this.callDetailForm.value.type) {
      case "D": return "Defeito";
      case "P": return "Problema";
      case "A": return "Solicitação de Alteração";
      default: case "I": return "Incidente";
    }
  }

  public saveEditorText({editor}: ChangeEvent) {
    const data = editor.getData();
    this.textHasChanged.emit(data)
  }

  public typeChanged() {
    this.typeHasChanged.emit(this.callDetailForm.value.type)
  }

  public priorityChanged() {
    this.priorityHasChanged.emit(this.callDetailForm.value.priority)
  }
}
